import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from '@core/core.module';
import { LayoutModule } from '@layout/layout.module';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';



@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule, 
        BrowserAnimationsModule, 
        AppRoutingModule, 
        CoreModule, 
        LayoutModule,
        ToastModule
    ],
    providers: [MessageService],
    bootstrap: [AppComponent],
})
export class AppModule {}
